import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class IdArgs {
  @Field(type => Int)
  id!: number
}
